import React, { Component } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { inspectionDashboardDocument } from '../store/actions/qaTemplateActions';
import { getPODetails, getPOSearch } from '../store/actions/poDetailsActions'
import { WaiveOffInspection } from '../store/actions/dispatchOrderDetailsActions'
import { getstagesByPOLineitemID, requestForVendorApproval, changeDocStatus, postAddStage, removeStage, GetDocumentsForQA, getQADocumentsByParams, postQADocumentForPOLineitemID, updateQADocumentStatus, getQAActivity, postComment, getPODetailsWithPoLineItemId } from '../store/actions/poDetailsActions'
import { uploadFile, downloadFile, getDocumentVersions, uploadVersionFile, uploadFileGeneric, GenericUploadVersionFile } from '../store/actions/fileActions.js'
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropdownFlat from '../Components/DropdownFlat'
import { Link } from 'react-router-dom';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import AuthHandlerInstance from '../Classes/AuthHandler'
import formatDate from '../Classes/FormatDate'
import FileVersionModal from '../Components/FileVersionModal';
import DocumentRevisePopUp from '../Components/DocumentRevisePopUp';
import DocumentRejectPopUp from '../Components/DocumentRejectPopUp';
import DocumentCommentsPopUp from '../Components/DocumentCommentsPopUp';
import swal from '@sweetalert/with-react'
// import SuccessFailureModal from '../Components/Success_Failure_Modal';
import '../App.scss';
import env from '../ENV';
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import toast from 'react-hot-toast';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import TableComp from '../Components/ReusableTable';
import formatTime from '../Classes/FormatTime';



const ROOT_URL = env.BACKEND_URL;
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.sendToVendor = this.sendToVendor.bind(this);
        this.validateButtonStatus = this.validateButtonStatus.bind(this);
        this.state = {
            userId: AuthHandlerInstance.getUserID(),
            // bgColor:'#94C973',
            activeEventKey: 0,
            modal: false,
            // UploadSuccessModal:false,
            // ChangeText:"",
            // hTitle:"",
            // iconCol:"",
            // iconName:"",
            OpenVersionModal: false,
            PoLineItemData: {},
            opacity: "",
            dropdowndata: [
                { value: 1, label: "Approve" },
                { value: 2, label: "Reject" },
                { value: 3, label: "Revise" }],
            Date: [
                { value: 1, label: "Ascending" },
                { value: 2, label: "Descending" }],
            poID: this.props.location.state.poid,
            poLineItem: this.props.location.state.itemNo,
            purchaseOrderId: this.props.location.state.po,
            purchaseLIneItemID: this.props.location.state.polineitemID,
            status: this.props.location.state.status ? this.props.location.state.status : "PO Created",
            selectedFile: [],
            selectedfilestageId: [],
            stageIds: [],
            docStatus: {
                1: { title: "Saved as draft", badge: "badge-secondary" },
                2: { title: "Document saved", badge: "badge-warning" },
                3: { title: "Accepted", badge: "badge-success" },
                4: { title: "Rejected", badge: "badge-danger" },
                5: { title: "Required another revised document", badge: "badge-danger" }
            },
            qaDocStatus: {
                1: { title: "Document is Approved", badge: "badge-success", status: "Approved" },
                2: { title: "Document is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "Document sent for Revision", badge: "badge-primary", status: "Sent for Revision" },
                0: { title: "Document Uploaded", badge: "badge-warning", status: "Document Uploaded" },
                null: { title: "Document to be Submitted", badge: "badge-warning", status: "" },

            },
            btnStatus: [],
            versionList: [],
            selectedFileVersion: [],
            selectedfilestageIdVersion: [],
            stageIdsVersion: [],
            fileUploadIds: [],
            uploadedId: "",
            revisedPayload: [],
            totalStagesApproved: 0,
            totalStages: 0,
            showRevisedPopUp: false,
            showRejectPopUp: false,
            showCommentPopUp: false,
            uploadedfile: false,
            // selectedFile: {}
            modalWaiveOff: false,
            proposedQty: 0,
            CSMTLink: '',
            enableQADocument: false,
            document: '',
            qaDocumentFile: '',
            documentFile: '',
            approvalStatus: {
                approved: 1,
                rejected: 2,
                revise: 3
            },
            modalQAActivity: false,
            selectedItem: {},
            poLineItemDetails:{},
        }
        this.modal = this.modal.bind(this);
        // this.UploadSuccessModal= this.UploadSuccessModal.bind(this); 
        this.OpenVersionModal = this.OpenVersionModal.bind(this);
        this.changeDocStatus = this.changeDocStatus.bind(this);
        this.dateformate = this.dateformate.bind(this);
        this.qaDocumentRef = React.createRef()
        this.qaDocumentRef.current = []

    }

    modal() {
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }
    // UploadSuccessModal() {
    //     this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });
    //     this.setState({ RetentionDocumentsModal: false });
    //     if(this.state.UploadSuccessModal ==true){
    //         this.setState(
    //         {opacity:""}
    //         )
    //     }
    //     else{
    //         this.setState(
    //            {opacity:"0.2"} 
    //         ) 
    //     }
    // }

    // toggleSuccessModal(e){
    //     this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });
    //     if(this.state.UploadSuccessModal ==true){
    //         this.setState(
    //             {opacity:""}
    //         )
    //     }
    //     else{
    //         this.setState(
    //             {opacity:"0.2"} 
    //         )
    //     }
    // }

    async OpenVersionModal(uploadedId) {
        let versionList = [];

        //
        // if(this.state.OpenVersionModal ==false){
        //     this.setState({opacity:"0.2"})
        // }else{
        //     this.setState({opacity:""})
        // }
        let stateVal = this.state.OpenVersionModal;
        this.setState({ OpenVersionModal: !stateVal, uploadedId: uploadedId });

    }


    handleSelect = (e) => {
        console.log("drop", e.target.value);
        console.log("drop", e.target.key);
        this.setState({
            selected: e.target.value
        })
        alert(JSON.parse(e))
    }

    handleFileInput = (event, documentTypeId, stageId, uploadId) => {

        console.log(event, documentTypeId, stageId, uploadId)

        if (uploadId) {
            let selectedFileVersion = [...this.state.selectedFileVersion]
            selectedFileVersion.push(event.target.files[0])
            let selectedfilestageIdVersion = [...this.state.selectedfilestageIdVersion];
            selectedfilestageIdVersion.push(documentTypeId)
            let stageIdsVersion = [...this.state.stageIdsVersion];
            stageIdsVersion.push(stageIdsVersion);

            let fileUploadIds = this.state.fileUploadIds;
            fileUploadIds.push(uploadId);
            this.setState({ selectedFileVersion, selectedfilestageIdVersion, stageIdsVersion, fileUploadIds, uploadedfile: true });
            return true;
        }

        let selectedFile = [...this.state.selectedFile]
        let selectedfilestageId = [...this.state.selectedfilestageId]
        selectedFile.push(event.target.files[0])
        selectedfilestageId.push(documentTypeId)
        let stageIds = [...this.state.stageIds];
        stageIds.push(stageId);
        this.setState({ selectedFile, selectedfilestageId, stageIds });
        // for(let i=0;i<this.state.fileSize.length;i++)
        // {
        //     if(i===documentTypeId)
        //         this.state.fileSize[i-2] = parseFloat((event.target.files[0].size)/(Math.pow(1024,2))).toFixed(2)    
        // }
        console.log("selectedFile=", selectedFile)
        if (selectedFile.length > 0) {
            let uploadedfile = true
            this.setState({ uploadedfile })
        }



        //console.log("SelectedFile",selectedFile)
    }

    uploadFile = () => {
    }
    onClickSave = async () => {

        if (this.state.selectedFile.length < 1 && this.state.selectedFileVersion.length < 1) {
            swal("Please upload some valid document", { icon: "error" })

            return false;
        }

        swal("Document is uploading...", { button: false, icon: "info" })
        await this.props.uploadFile(this.state.selectedFile, this.state.selectedfilestageId, this.state.purchaseOrderId, this.state.purchaseLIneItemID, this.state.stageIds);

        //upload new version
        await this.props.uploadVersionFile(this.state.selectedFileVersion,
            this.state.selectedfilestageIdVersion,
            this.state.purchaseOrderId,
            this.state.purchaseLIneItemID,
            this.state.stageIdsVersion,
            this.state.fileUploadIds, "", [1]);
        await this.setState({ selectedFile: [], selectedfilestageId: [], stageIds: [] });

        await this.datasync()

        await this.setState({
            uploadedfile: false
        })

        console.log(this.state.docStatus)

    }

    downloadFile = (uploadid) => {
        this.props.downloadFile(uploadid)
    }

    componentDidMount() {
        this.datasync()
    }

    datasync = async () => {
        await this.props.GetDocumentsForQA()
        await this.props.getQADocumentsByParams({
            PurchaseOrderId: this.state.purchaseOrderId,
            PurchaseOrderLineId: this.state.purchaseLIneItemID
        })
        console.log(this.props.qaDocuments, 'qaDocuments')
        await this.props.getstagesByPOLineitemID(this.state.purchaseOrderId, this.state.purchaseLIneItemID)
            .then(async () => {
                var totalStagesApproved = 0
                var totalStages = 0
                if (this.props.poDetails.stagesByPOLineitemID && this.props.poDetails.stagesByPOLineitemID.templates && this.props.poDetails.stagesByPOLineitemID.templates.stages && this.props.poDetails.stagesByPOLineitemID.templates.stages.length > 0) {
                    totalStages = await this.props.poDetails.stagesByPOLineitemID.templates.stages.length
                    for (let i = 0; i < this.props.poDetails.stagesByPOLineitemID.templates.stages.length; i++) {
                        const element = this.props.poDetails.stagesByPOLineitemID.templates.stages[i];
                        if (element.isStageComplete == 1 && element.isAllDocumentsSubmitted == 1) {
                            await totalStagesApproved++
                        }
                    }
                }
                console.log(totalStagesApproved, totalStages, 'stagecout')
                await this.setState({ PoLineItemData: this.props.poDetails.stagesByPOLineitemID, totalStages, totalStagesApproved })
            })
        await this.props.getPODetailsWithPoLineItemId({PurchaseOrderId: this.state.purchaseOrderId, PurchaseOrderLineId: this.state.purchaseLIneItemID}).then( ()=>{
        
            let pendingQty = parseFloat(this.props.poDetails.poLineItemDetails[0].icqty) > 0 ? parseFloat(this.props.poDetails.poLineItemDetails[0].POLineItemQuantity) - parseFloat(this.props.poDetails.poLineItemDetails[0].icqty) : this.props.poDetails.poLineItemDetails[0].POLineItemQuantity  
            this.setState({poLineItemDetails: this.props.poDetails.poLineItemDetails[0], pendingQty: pendingQty }) 
            console.log('poLineItemDetails==', this.state.poLineItemDetails, this.state.pendingQty)
            })    
    }

    componentWillReceiveProps(next) {

        // if(next.file)

    }

    validateSaveBtn(records) {
        try {
            let status = true;
            for (let i = 0; i < records.documents.length; i++) {
                if (records.documents[i]['uploadId'] == 0) {
                    status = false;
                    break;
                }
            }

            return status
        } catch (e) {
            return false;
        }
    }

    async sendToVendor(records) {
        try {
            let status = false;
            for (let i = 0; i < records.documents.length; i++) {
                if (records.documents[i]['uploadId'] != 0) {
                    status = true;
                    // this.modal();
                    break;
                }
            }
            if (!status) return false;

            var roles = AuthHandlerInstance.getRoles()
            records.allDocumentStatus = 2;
            records.isSMS = roles[6] ? true : false
            let poDetail = this.props.poDetails.stagesByPOLineitemID;
            records.poLineItemId = poDetail.poLineItemId;
            records.poId = poDetail.poId;
            await this.props.requestForVendorApproval(records);
            await this.datasync()
        } catch (e) {
            console.log(e);
        }
    }

    async changeDocStatus(status, uploadId, qATemplateStageId) {
        console.log(qATemplateStageId, "[[[[[[[[[[[[[[[[[[[[[[")
        this.props.changeDocStatus({ status, uploadId, qATemplateStageId });
        this.props.getstagesByPOLineitemID(this.state.purchaseOrderId, this.state.purchaseLIneItemID)
    }

    validateSendToVendorSaveBtn(records) {
        try {

            let status = true;
            for (let i = 0; i < records.documents.length; i++) {
                if (records.documents[i]['uploadId'] != 0 && records.documents[i]['status'] < 2) {
                    status = false;
                    break;
                }
            }
            console.log(records, status, "Demo");
            return status
        } catch (e) {
            return false;
        }
    }

    async validateButtonStatus() {
        if (this.props.poDetails.stagesByPOLineitemID && this.props.poDetails.stagesByPOLineitemID.templates && this.props.poDetails.stagesByPOLineitemID.templates.stages) {
            let status = this.state.btnStatus;
            await this.props.poDetails.stagesByPOLineitemID.templates.stages.map((element) => {

                if (!status[element['stageId']]) {
                    status[element['stageId']] = { save: false, vendor: false };

                }
                status[element['stageId']]['save'] = this.validateSaveBtn(element)
                status[element['stageId']]['vendor'] = this.validateSendToVendorSaveBtn(element)

                console.log(status[element['stageId']], "status[element['stageId']]");

            });

            this.setState({ btnStatus: status });
        }
    }

    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    revisePopUpAction = async (reviseParam, popUpStatus, refreshPage) => {

        this.setState({ revisedPayload: reviseParam, showRevisedPopUp: popUpStatus });
        if (refreshPage) {
            await this.datasync()
        }
    }

    rejectPopUpAction = async (reviseParam, popUpStatus, refreshPage) => {

        this.setState({ revisedPayload: reviseParam, showRejectPopUp: popUpStatus });
        if (refreshPage) {
            await this.datasync()
        }
    }

    // Add Stage
    addStage = async (stageId, templateId) => {
        var stageData = {
            stageId: stageId,
            templateId: templateId,
            seqNumber: this.props.poDetails.stagesByPOLineitemID.templates.stages.length,
            StageCounter: this.props.poDetails.stagesByPOLineitemID.templates.stages.filter((item) => item.stageId === stageId).length
        }

        console.log("o;iuytrdsa", this.state.purchaseOrderId, this.state.purchaseLIneItemID, stageData)

        await this.props.postAddStage(this.state.purchaseOrderId, this.state.purchaseLIneItemID, stageData)

        await this.datasync()

    }

    removeStage = async (element) => {
        console.log(element, '----')

        await this.props.removeStage(this.state.purchaseOrderId, this.state.purchaseLIneItemID, element.qATemplateStageId)

        await this.datasync()
    }

    documentComments = async (reviseParam, uploadId) => {
        let stateVal = this.state.showCommentPopUp;
        this.setState({ revisedPayload: reviseParam, showCommentPopUp: !stateVal, uploadedId: uploadId });
    }

    waiveOffInspection = async (e) => {
        if (this.state.proposedQty > this.state.pendingQty) {
            swal("Please check the quantity entered! It can not be more than pending quantity", { icon: "error", button: true })
            return false;
        }
        if (this.state.proposedQty === 0 || this.state.proposedQty === null || this.state.proposedQty === '') {
            swal("Please enter quantity!", { icon: "error", button: true })
            return false;
        }
        if (this.state.CSMTLink === '') {
            swal("Please enter CSMT Link!", { icon: "error", button: true })
            return false;
        }
        swal("Processing...", { icon: "info", button: false })
        let input = {
            PurchaseOrderLineId: this.state.purchaseLIneItemID,
            status: 'Stage- Final  Review, Verification/Inspection is Completed / Waived Off',
            proposedQty: this.state.proposedQty,
            CSMTLink: this.state.CSMTLink,
        }
        await this.props.WaiveOffInspection(input)
        swal("Inspection has been Waived Off", { icon: "success", button: true })
        await this.modalWaiveOff()
        await this.setState({ proposedQty: 0, CSMTLink: '' })
        await this.datasync()
    }
    modalWaiveOff() {
        this.setState({ modalWaiveOff: !this.state.modalWaiveOff });
    }
    handleProposedQty = (e) => {
        let input = e.target.value
        this.setState({ proposedQty: input })
    }
    handleCSMT = (e) => {
        let input = e.target.value
        this.setState({ CSMTLink: input })
    }

    toggleAddQADocument = async () => {
        this.setState({
            enableQADocument: !this.state.enableQADocument
        })
    }

    handleDocument = async (e) => {
        this.setState({ document: e.target.value })
    }

    handleQADocumentFileInput = async (e) => {
        this.setState({ qaDocumentFile: e.target.files[0] })
    }

    handleDocumentFileInput = async (e) => {
        this.setState({ documentFile: e.target.files[0] })
    }

    submitDocument = async () => {
        if (this.state.document == '') {
            swal("Please select document", { icon: "error", button: true })
            return false;
        }
        if (this.state.documentFile == '') {
            swal("Please upload some file", { icon: "error", button: true })
            return false;
        }
        var result = await this.props.uploadFileGeneric([this.state.documentFile], AuthHandlerInstance.getUserID())
        var versionId = result.results[0].VersionId
        var documentId = result.results[0].DocumentId

        await this.props.postQADocumentForPOLineitemID({
            DocumentTypeId: this.state.document,
            DocumentId: documentId,
            VersionId: versionId,
            ActedBy: AuthHandlerInstance.getUserID(),
            PurchaseOrderId: this.state.purchaseOrderId,
            PurchaseOrderLineId: this.state.purchaseLIneItemID,
        })
        await this.setState({ documentFile: '', document: '' });

        await this.datasync()
    }

    submitReviseDocument = async (params) => {
        if (this.state.qaDocumentFile == '') {
            swal("Please upload some file", { icon: "error", button: true })
            return false;
        }
        console.log(this.state.qaDocumentFile, 'this.state.qaDocumentFile')
        var result = await this.props.GenericUploadVersionFile([this.state.qaDocumentFile], params.DocumentId, "", AuthHandlerInstance.getUserID())
        swal("Processing...", { icon: "info", button: false })
        var VersionId = result.results[0].VersionId
        var DocumentId = params.DocumentId

        await this.props.updateQADocumentStatus({
            DocumentId: DocumentId,
            VersionId: VersionId,
            Status: 0,
            ActedBy: AuthHandlerInstance.getUserID(),
            Comments: "",
        })
        await this.setState({ qaDocumentFile: '' });
        swal("Document uploaded", { icon: "success", button: false })
        this.qaDocumentRef.current[params.DocumentId].value = ""

        await this.datasync()
    }

    submitRevisePopUpForm = async (params) => {
        var VersionId = this.state.revisedPayload.param.VersionId
        console.log(params, this.state.revisedPayload, 'Popup form submitted')
        if (params.files && params.files.length > 0) {
            var result = await this.props.GenericUploadVersionFile(params.files, this.state.revisedPayload.param.DocumentId, params.comments, AuthHandlerInstance.getUserID())
            VersionId = result.results[0].VersionId
        }
        await this.props.updateQADocumentStatus({
            DocumentId: this.state.revisedPayload.param.DocumentId,
            VersionId: VersionId,
            Status: this.state.revisedPayload.Status,
            ActedBy: AuthHandlerInstance.getUserID(),
            Comments: params.comment,
        })
        await this.submitComment(params)
        await this.revisePopUpAction({}, false, true)
    }

    submitComment = async (params) => {
        var IsSMS = 0
        var commentedBy = ""
        var roles = AuthHandlerInstance.getRoles()
        if (roles["5"]) {
            IsSMS = 0
            commentedBy = "Supplier"
        } else {
            IsSMS = 1
            commentedBy = "SMS"
        }

        let param = {
            purchaseOrderId: this.state.purchaseOrderId,
            purchaseLIneItemID: this.state.purchaseLIneItemID,
            stageDocumentId: this.state.revisedPayload.param.QADocumentId,
            comment: params.comment,
            uploadId: this.state.revisedPayload.param.DocumentId,
            status: this.state.revisedPayload.Status,
            actedBy: AuthHandlerInstance.getUserID(),
            IsSMS: IsSMS,
            documentTypeId: this.state.revisedPayload.param.DocumentTypeId,
            commentedBy: commentedBy
        }
        await this.props.postComment(param)
    }

    modalQAActivity = async (poRowData) => {
        // this.setState({})
        // console.log(poRowData)
        if (poRowData) {
            this.setState({ selectedItem: poRowData })
            await this.props.getQAActivity({
                DocumentId: poRowData.DocumentId
            })
        } else {
            this.setState({ selectedItem: {} })
        }
        this.setState({ modalQAActivity: !this.state.modalQAActivity });

        if (this.state.modalQAActivity === true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    render() {
        console.log("poiuytfdcvbnkj1", this.state.PoLineItemData, this.state.PoLineItemData.DeletionIndicator)
        var roles = AuthHandlerInstance.getRoles()
        var permissions = AuthHandlerInstance.getPermissions()
        console.log("required PO data :", this.state.poID, this.state.poLineItem, this.state.purchaseOrderId, this.state.purchaseLIneItemID, this.state.icqty, this.state.POLineItemQuantity)
        console.log("Roles", roles)
        console.log("Permissions", permissions)
        console.log(this.state.userId, 'this.state.userId')
        console.log(
            this.state.PoLineItemData.templates && this.state.PoLineItemData.templates.stages.sort(function (a, b) {
                return a.stageId - b.stageId || a.SeqNumber - b.SeqNumber
            }), "sorting"
        )

        const tableConstants = () => {
            return [
                {
                    title: 'Document Name',
                    render: rowData => {
                        return <span className="text-center">{rowData.DocumentTypeName}</span>;
                    },
                },
                {
                    title: 'Uploaded By',
                    render: rowData => {
                        return <span className="text-center">{rowData.UploadedBy}</span>
                    },
                },
                {
                    title: 'Uploaded On',
                    render: rowData => {
                        return <div className="text-center" style={{ minWidth: "100px" }}>{rowData.CreatedOn ? dateFormater(rowData.CreatedOn) : ""}</div>
                    },
                },
                {
                    title: 'Action',
                    render: rowData => {
                        return <>
                            <div className="row text-center d-none d-sm-block headeralign">
                                {rowData.DocumentId != 0 ?
                                    <>
                                        <FontAwesomeIcon
                                            className="align-middle mt-2 pr-2"
                                            icon={"code-branch"}
                                            cursor="pointer"
                                            color={"black"}
                                            title="Document Version"
                                            size="2x" onClick={() => this.OpenVersionModal(rowData.DocumentId)} />
                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentId + "/download"} target="_blank" download>
                                            <FontAwesomeIcon icon={"file-download"} className="align-middle mt-2 pr-2" title="Download" color={"black"} cursor="pointer" size="2x" />
                                        </a>
                                        {rowData.Status == 0 && this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator &&
                                            <>
                                                {permissions[18] &&
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" cursor="pointer" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1, Status: this.state.approvalStatus.approved }, true)} />
                                                }
                                                {permissions[19] &&
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" cursor="pointer" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: rowData, qATemplateStageId: 1, Status: this.state.approvalStatus.revise }, true)} />
                                                }
                                            </>
                                        }
                                        {(rowData.Status == 3 || rowData.Status == 0) && this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator &&
                                            permissions[17] &&
                                            <>
                                                <input type="file" ref={(ref) => { this.qaDocumentRef.current[rowData.DocumentId] = ref; return true; }} onChange={(e) => this.handleQADocumentFileInput(e)} id="exampleFormControlFile1" />
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"cloud-upload-alt"} color={"black"} title="Upload Document" size="2x" onClick={() => this.submitReviseDocument(rowData)} />
                                            </>
                                        }
                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"} color={"block"} title="Comments" size="2x" cursor="pointer" onClick={() => this.documentComments({ actionType: "Supplier Documents", param: rowData }, rowData.DocumentId)} />
                                        < FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"info-circle"} cursor="pointer" color={"black"} title="View Info" size="2x" onClick={() => this.modalQAActivity(rowData)} />
                                    </>
                                    : null}
                            </div>
                            <div className="row text-center d-none d-sm-block headeralign">
                                <span className={"badge " + this.state.qaDocStatus[rowData.Status]['badge']}>
                                    {this.state.qaDocStatus[rowData.Status]['status']}
                                </span>
                            </div>
                        </>
                    },
                },
            ];
        };
        // this.validateButtonStatus();
        return (
            <div className="Container-fluid ">

                {/* ----Modal Start----- */}
                {/* <SuccessFailureModal action={this.state.UploadSuccessModal} toggleSuccessModal={(e)=>this.toggleSuccessModal(e)} headertitle={this.state.hTitle} text= {this.state.ChangeText} icon={this.state.iconName} iconcolor={this.state.iconCol} path='/InspectiondashboardDocument' />             */}
                {/* ----Modal End----- */}
                {/* ----------QA Activity Modal Start---------------- */}
                <Modal isOpen={this.state.modalQAActivity} className="modal-xl mr-2">
                    <div className={"modal-bg" + (this.state.modalQAActivity === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Activity Details : {this.state.selectedItem.DocumentTypeName}</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => this.modalQAActivity()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row">
                                    <div className="col">
                                        <table border="1" className="table5 table" >
                                            <thead>
                                                <tr className="headerbar ">
                                                    <th>Action</th>
                                                    <th>Acted By</th>
                                                    <th>Acted On</th>
                                                    <th>Acted Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.qaActivity && this.props.qaActivity.length > 0 && this.props.qaActivity.map((item, index) =>
                                                    <tr key={index} className="rows headeralign">
                                                        <td>{item.ActionName}</td>
                                                        <td>{item.UploadedBy}</td>
                                                        <td>{item.CreatedOn ? dateFormater(item.CreatedOn) : '----'}</td>
                                                        <td>{item.CreatedOn ? formatTime(item.CreatedOn) : '----'}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                    </div>
                </Modal>
                {/* ----------QA Activity Modal End---------------- */}

                {/* ----Modal Start----- */}

                <Modal isOpen={this.state.modalWaiveOff} >
                    <div className={"modal-bg" + (this.state.modalWaiveOff === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div className=" row pl-3"><h4>Waive Off Final Call</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => this.modalWaiveOff()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <ModalBody Style="modal-body">
                            <div className='row'>
                                <div className='col-4'><b>Line Item Qty. :</b></div>
                                <div className='col-8' style={{ display: 'flex' }}>
                                    <input className='form-control' value={this.state.poLineItemDetails.POLineItemQuantity} disabled />
                                    <input className='form-control' value={this.state.poLineItemDetails.OrderUnit} disabled style={{ fontWeight: 'bold' }} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-4'><b>Pending Qty. :</b></div>
                                <div className='col-8' style={{ display: 'flex' }}>
                                    <input className='form-control' value={this.state.pendingQty > 0 ? (this.state.pendingQty).toFixed(2) : this.state.pendingQty} disabled />
                                    <input className='form-control' value={this.state.poLineItemDetails.OrderUnit} disabled style={{ fontWeight: 'bold' }} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-4'><b>Enter Qty. :</b></div>
                                <div className='col-8' style={{ display: 'flex' }}>
                                    <input className='form-control' value={this.state.proposedQty} onChange={(e) => this.handleProposedQty(e)} />
                                    <input className='form-control' value={this.state.poLineItemDetails.OrderUnit} disabled style={{ fontWeight: 'bold' }} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-4'><b>CSMT Link :</b></div>
                                <div className='col-8'><input className='form-control' placeholder='Enter CSMT Link' value={this.state.CSMTLink} onChange={(e) => this.handleCSMT(e)} /></div>
                            </div>
                        </ModalBody>
                        <ModalFooter FooterStyle="modal-footer">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-4 rounded-pill float-right" onClick={() => this.waiveOffInspection(this.state.purchaseLIneItemID)} type="submit">Submit</button>
                                <button className="btn2 btn-sms1 mt-2 ml-4 rounded-pill float-right" onClick={() => this.modalWaiveOff()} type="submit">Close</button>
                            </div>
                        </ModalFooter>
                    </div>
                </Modal>
                <Modal isOpen={this.state.modal} >
                    <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div className=" row pl-3"><h4>Documents Submission</h4></div>
                                <Link to={{ pathname: '/QAplanningdashboard', state: {} }}>
                                    <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </Link>
                            </ModalHeader>
                        </div>
                        <div className="modalbodys">
                            <ModalBody Style="modal-body modalbodys">

                                <div className="row text-center pb-2">
                                    <FontAwesomeIcon icon={'check-circle'} className="submission-check-cirle" color="green" size="10x" />
                                </div>

                                <div className="row pl-2 text-center">
                                    Your documents related to Kick Off Meeting Document have been sent to SMS India successfully.
                                </div>
                                <div className="row pt-4 pr-2 float-right">
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={this.modal} type="submit">OK</button>
                                </div>
                            </ModalBody>
                        </div>
                        {/* <div className="modalbodys">     */}
                        <ModalFooter>
                            {/* <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">OK</button>
                </div>              */}
                        </ModalFooter>
                    </div>
                </Modal>


                {/* ----Modal End-------- */}
                {/* ---------- Version Modal Start -------------*/}
                {this.state.uploadedId && this.state.OpenVersionModal && <FileVersionModal uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
                {/* ---------- Vendor Modal End -------------*/}

                {/*---------Document Revise popup */}
                {this.state.showRevisedPopUp && <DocumentRevisePopUp submitPopUpForm={(params) => this.submitRevisePopUpForm(params)} revisePopUpAction={(payLoad, status, callAct) => this.revisePopUpAction(payLoad, status, callAct)} showRevisedPopUp={this.state.showRevisedPopUp} revisedPayload={this.state.revisedPayload} purchaseLIneItemID={this.state.purchaseLIneItemID} purchaseOrderId={this.state.purchaseOrderId} />}
                {/*---------Document Revise popup End */}

                {/*---------Document Reject popup */}
                {this.state.showRejectPopUp && <DocumentRejectPopUp submitPopUpForm={() => this.submitRejectPopUpForm()} rejectPopUpAction={(payLoad, status, callAct) => this.rejectPopUpAction(payLoad, status, callAct)} showRejectPopUp={this.state.showRejectPopUp} revisedPayload={this.state.revisedPayload} purchaseLIneItemID={this.state.purchaseLIneItemID} purchaseOrderId={this.state.purchaseOrderId} />}
                {/*---------Document Reject popup End */}

                {/*----------Document comment-------------- */}
                {this.state.showCommentPopUp && <DocumentCommentsPopUp showCommentPopUp={this.state.showCommentPopUp} docStatus={this.state.docStatus} uploadedId={this.state.uploadedId} revisedPayload={this.state.revisedPayload} purchaseLIneItemID={this.state.purchaseLIneItemID} purchaseOrderId={this.state.purchaseOrderId} documentComments={(payLoad, id) => this.documentComments(payLoad, id)} />}
                {/*----------Document Comment end  */}

                <div className="Container-fluid p-4" style={{ opacity: this.state.opacity }} >
                    <div className="row ">
                        <div className="col-md-7">
                            <p className='header'>
                                <b>INSPECTION DASHBOARD - DOCUMENTS DASHBOARD FOR SUPPLIER</b>
                            </p>
                        </div>
                        {
                            this.state.poLineItemDetails.icqty != this.state.poLineItemDetails.POLineItemQuantity ?
                                (roles[1] || roles[3] || roles[4] || roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] || roles[53] ?
                                    <div className="">
                                        <a className="btn2 btn-sms1 rounded-pill" disabled={this.state.totalStages !== this.state.totalStagesApproved} onClick={(e) => this.state.totalStages !== this.state.totalStagesApproved ? "" : this.modalWaiveOff()}>Waive Off Final Call</a>
                                    </div>
                                    : null)
                                : null
                        }
                        {permissions[20] ?
                            <div className="">
                                <Link to={{ pathname: '/Supplier/RequestInspection', state: {} }}>
                                    <button className="btn2 btn-sms1 mt-2 rounded-pill" type="button"> Request Inspection </button>
                                </Link>
                            </div>
                            : null}

                        {roles[1] || roles[3] || roles[4] || roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] || roles[53] ?
                            <div className="">
                                <a className="btn2 btn-sms1 rounded-pill" href={FILESERVER_ROOT_URL + "files/inspection-binder/" + this.state.purchaseLIneItemID + "/download"} target="_blank">Download Binder</a>
                            </div>
                            : null}
                    </div>

                    <div className="row pb-4 ">
                        <div className="col  "><b>PO Number:</b> {this.state.poID}</div>
                        <div className="col "><b>PO Item:</b> {this.state.poLineItem}</div>
                        <div className="col "><b>Manufacture Status:</b> {this.state.PoLineItemData.isHold === 1 ? 'Hold' : '---'}</div>
                        <div className="col "><b>Status:</b> {this.state.status}</div>
                    </div>
                    {/* Legend */}
                    {/* <div className="row pb-4">
                        <div className="col-md-3" ><b>Document Submission Status:</b></div>
                        <div className="col-md-1" >
                            <CircularProgressbarWithChildren value={80} strokeWidth={50} styles={buildStyles({ pathColor: "green", strokeLinecap: "butt" })}>
                                <FontAwesomeIcon className="" icon={"file-alt"} color={"white"} title="Accept" size="1x" />
                            </CircularProgressbarWithChildren>
                        </div>
                        <div className="col-md-3" ><b>Stage Completion Status:</b></div>
                        <div className="col-md-1" >
                            <CircularProgressbarWithChildren value={80} strokeWidth={50} styles={buildStyles({ pathColor: "green", strokeLinecap: "butt" })}>
                                <FontAwesomeIcon className="" icon={"file-alt"} color={"white"} title="Accept" size="1x" />
                            </CircularProgressbarWithChildren>
                        </div>
                        </div> */}
                    {/* Legend */}
                    {/* -------------Accordion---------- */}

                    <div className="row pr-4 ">
                        {permissions[17] &&
                            <div className="col-12">
                                <button type='button' className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.toggleAddQADocument()}>Add Document</button>
                            </div>
                        }
                        {this.state.enableQADocument ?
                            <div className="col-12">
                                <div className="row">
                                    <div className="col form-group">
                                        <select className='form-control' onChange={(e) => { this.handleDocument(e) }}>
                                            <option disabled selected>Select Document</option>
                                            {this.props.qaDocuments.map((document) => {
                                                return <option value={document.DocumentTypeId}>{document.DocumentTypeName}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className='col form-group'>
                                        <input type="file" className="form-control-file" style={{ width: "79%", float: "rigth" }} accept=".pdf" onChange={(e) => { this.handleDocumentFileInput(e) }} id="exampleFormControlFile1" />
                                    </div>
                                    <div className='col form-group'>
                                        <button className="btn2 btn-sms1 rounded-pill" onClick={() => this.submitDocument()} type="submit">Submit</button>
                                    </div>
                                </div>
                            </div>
                            : ""
                        }
                    </div>
                    <div className="row pr-4 ">
                        <div className="col md-10   " style={{ cursor: 'pointer' }}>
                            <TableComp
                                cols={tableConstants()}
                                data={this.props.qaDocumentsByPOLineItemId} />
                            {this.state.PoLineItemData.templates && this.state.PoLineItemData.templates.stages.length > 0 ?
                                < Accordion >
                                    {
                                        this.state.PoLineItemData.templates ? this.state.PoLineItemData.templates.stages.map((element, index) => {
                                            console.log("poiuytfdcvbnkj", element, index)
                                            let totalDocsCount = 0;
                                            let uploadedDocs = 0;
                                            let applicablecount = 0
                                            let statuscount = 0;
                                            let checkingstatus = 0
                                            element.documents.forEach((doc) => {
                                                if (doc.isRequired === 1) {
                                                    totalDocsCount += 1
                                                }
                                                if (doc.isRequired === 1 && doc.uploadId > 0) {
                                                    uploadedDocs += 1
                                                }
                                                else if (doc.isRequired === 0 && doc.uploadId > 0) {
                                                    applicablecount += 1
                                                    if (doc.status === 2) {
                                                        statuscount += 1
                                                    }
                                                    console.log("lkjhgvfcvbsna", element.documents.length, doc.uploadId, applicablecount, index)
                                                }
                                            });
                                            if (totalDocsCount > 0) {
                                                element.TotatlDocumentCount = totalDocsCount
                                            }
                                            if (uploadedDocs > 0) {
                                                element.UploadedDocumentCount = uploadedDocs
                                            }
                                            if (element.documents.length === applicablecount) {
                                                element.TotatlDocumentCount = 0
                                                element.UploadedDocumentCount = 0
                                                element.isAllDocumentsSubmitted = 1
                                                element.isStageComplete = 1
                                            }
                                            if (statuscount > 0 && element.documents.length === applicablecount && element.documents.length === statuscount) {
                                                checkingstatus = 1
                                                element.ApprovedDocumentCount = null
                                            }
                                            return (<div><Card event>
                                                <div className={"accordion-background " + (this.state.activeEventKey === JSON.stringify(index) ? 'active' : '')}>
                                                    <div className="col-md-10 float-left">
                                                        <Accordion.Toggle
                                                            as={Card.Header} eventKey={JSON.stringify(index)} onClick={() => this.setState({ activeEventKey: JSON.stringify(index) })}>
                                                            {element.stageName + " " + (element.StageCounter && element.StageCounter != null ? element.StageCounter : '')}
                                                        </Accordion.Toggle>
                                                    </div>
                                                    <table className="col-md-4 float-right mt-1 mb-1" style={{ width: 120 }}>
                                                        {(roles[5] || roles[7]) && this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator ?

                                                            <td className="pr-2">
                                                                {!element.StageCounter && element.ApprovedDocumentCount !== null && element.TotatlDocumentCount === element.ApprovedDocumentCount ?
                                                                    <FontAwesomeIcon className="" icon={"plus"} color="block" title="Add Stage" size="1x" onClick={() => this.addStage(element.stageId, this.props.poDetails.stagesByPOLineitemID.templates.id)} />
                                                                    : element.documents.filter((el) => el.uploadId != 0).length == 0 && element.StageCounter != null && (!this.props.poDetails.stagesByPOLineitemID.templates.stages[index + 1] || (this.props.poDetails.stagesByPOLineitemID.templates.stages[index + 1] && this.props.poDetails.stagesByPOLineitemID.templates.stages[index + 1].StageCounter < element.StageCounter)) ?
                                                                        <FontAwesomeIcon className="" icon={"minus"} color="block" title="Remove Stage" size="1x" onClick={() => this.removeStage(element)} />
                                                                        : null}
                                                            </td>
                                                            : null
                                                        }
                                                        <td className="pr-2">
                                                            {console.log("poiuytfdcvbnkj", element.UploadedDocumentCount, element.TotatlDocumentCount)}
                                                            <CircularProgressbarWithChildren
                                                                value={element.TotatlDocumentCount == null && element.UploadedDocumentCount == null ? 0 : Math.round((element.UploadedDocumentCount / element.TotatlDocumentCount) * 100)}
                                                                // background
                                                                // backgroundPadding={6}
                                                                strokeWidth={50}
                                                                styles={buildStyles({
                                                                    // Colors
                                                                    // backgroundColor: "#fff",
                                                                    // textColor: "#fff",
                                                                    pathColor: "green",
                                                                    // trailColor: "transparent"
                                                                    strokeLinecap: "butt"
                                                                })}>
                                                                {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
                                                                <FontAwesomeIcon className="" icon={"file-alt"} color={"white"} title="Document Status" size="1x" />
                                                            </CircularProgressbarWithChildren>
                                                        </td>
                                                        <td className="pr-2">
                                                            <CircularProgressbarWithChildren
                                                                value={(element.TotatlDocumentCount == null && element.ApprovedDocumentCount == null) || (element.TotatlDocumentCount == 0 && checkingstatus === 1) ? 0 : Math.round((element.ApprovedDocumentCount / element.TotatlDocumentCount) * 100)}
                                                                // background
                                                                // backgroundPadding={6}
                                                                strokeWidth={50}
                                                                styles={buildStyles({
                                                                    // Colors
                                                                    // backgroundColor: "#fff",
                                                                    // textColor: "#fff",
                                                                    pathColor: "green",
                                                                    // trailColor: "transparent"
                                                                    strokeLinecap: "butt"
                                                                })}>
                                                                {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
                                                                <FontAwesomeIcon className="" icon={"check-circle"} color={"white"} title="Approval Status" size="1x" />
                                                            </CircularProgressbarWithChildren>
                                                        </td>

                                                    </table>
                                                </div>
                                                <Accordion.Collapse eventKey={JSON.stringify(index)}>
                                                    <Card.Body>
                                                        <div className="pt-2">
                                                            {element.documents.map((el, index) => {
                                                                return (el.isSMS ? null : (<div className={"row pt-2" + (index % 2 ? "bg-light" : "") + "border"}>
                                                                    <div className="col-6 mt-2" style={{ textAlign: 'left' }}>{el.documentTypeName + (el.isRequired ? " (Required)" : " (If Applicable)")}</div>
                                                                    <div className="col mt-2" style={{ color: 'Blue', textAlign: 'center' }}>
                                                                        {el.isUploaded ? el.DocumentName : ""}</div>
                                                                    {(el.uploadId != 0 && (el.status > 1) && !roles[5] && !roles[7]) ? (<div className="col-ml-2 text-center" style={{ marginRight: "10px" }}>
                                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/" + el.uploadId + "/download"} target="_blank" download>
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px", marginRight: "5px" }} icon={"download"} color={"black"} title="Download" size="2x" />
                                                                        </a>
                                                                        <FontAwesomeIcon
                                                                            className="align-middle mt-2 pr-2"
                                                                            icon={"code-branch"}
                                                                            color={"black"}
                                                                            title="Document Version"
                                                                            size="2x" onClick={() => this.OpenVersionModal(el.uploadId)} />

                                                                        {this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator ?
                                                                            <FontAwesomeIcon className="align-middle float-right mt-2 pr-2" icon={"sms"} color={el.Comments == null || el.Comments ==
                                                                                'NA' ? "block" : 'blue'} title="Comments" size="2x" onClick={() => this.documentComments({ actionType: "Supplier Documents", param: el }, el.uploadId)} />
                                                                            : null}
                                                                        {
                                                                            el.status != 3 && this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator && ((this.state.PoLineItemData.ClaimbyId == this.state.userId) || roles[1] || roles[3] || roles[4] || roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] || roles[53]) ?
                                                                                <>
                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"check-circle"} color={"green"} title="Accept" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: el, status: 3, qATemplateStageId: element.qATemplateStageId }, true)} />
                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"times-circle"} color={"red"} title="Reject" size="2x" onClick={() => this.rejectPopUpAction({ actionType: "Supplier Documents", param: el }, true)} />
                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"history"} color={"blue"} title="Revise" size="2x" onClick={() => this.revisePopUpAction({ actionType: "Supplier Documents", param: el, qATemplateStageId: element.qATemplateStageId }, true)/*()=>this.changeDocStatus(5,el.uploadId)*/} />
                                                                                    {/* <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"}  color={"block"} title="Comments" size="2x" onClick={()=>this.documentComments({actionType:"Supplier Documents",param:el},el.uploadId)}/> */}
                                                                                </>
                                                                                : null}
                                                                        <><br />
                                                                            {console.log("lkjhyfdsa", el, this.state.docStatus[el.status])}
                                                                            <span className={"badge " + this.state.docStatus[el.status]['badge']} style={{ marginTop: "5px" }}>
                                                                                {el.status == 2 ? "Saved" : this.state.docStatus[el.status]['title']}
                                                                            </span></>



                                                                    </div>)
                                                                        : (<>

                                                                            {
                                                                                el.uploadId != 0 && el.status < 4 ?
                                                                                    <div className="col-ml-2 text-center" style={{ display: "inline-grid", marginRight: "10px" }}>
                                                                                        <div className="row ">
                                                                                            <div className="col">
                                                                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + el.uploadId + "/download"} target="_blank" download>
                                                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"download"} color={"black"} title="Accept" size="2x" />
                                                                                                </a>

                                                                                            </div>
                                                                                            <div className="col">
                                                                                                <FontAwesomeIcon
                                                                                                    className="align-middle mt-2 pr-2"
                                                                                                    icon={"code-branch"}
                                                                                                    color={"black"}
                                                                                                    title="Document Version"
                                                                                                    size="2x" onClick={() => this.OpenVersionModal(el.uploadId)} />

                                                                                            </div>
                                                                                            {this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator ?
                                                                                                <div className="col">
                                                                                                    <FontAwesomeIcon className="align-middle float-left mt-2 mr-6 pr-2" icon={"sms"} color={el.Comments == null || el.Comments == 'NA' ? "block" : 'blue'} title="Comments" size="2x" onClick={() => this.documentComments({ actionType: "Supplier Documents", param: el }, el.uploadId)} />
                                                                                                </div>
                                                                                                : null}
                                                                                        </div>
                                                                                        {console.log("lkjhyfdsa", el, this.state.docStatus[el.status])}
                                                                                        <span className={"badge " + (this.state.docStatus && this.state.docStatus[el.status] && "badge" in this.state.docStatus[el.status] ? this.state.docStatus[el.status]['badge'] : "")}>
                                                                                            {this.state.docStatus && this.state.docStatus[el.status] && "title" in this.state.docStatus[el.status] ? this.state.docStatus[el.status]['title'] : ""}
                                                                                        </span>


                                                                                    </div>
                                                                                    :
                                                                                    (roles[5] || roles[7]) ?
                                                                                        <div className="col mt-2 ml-4 text-center">
                                                                                            {this.state.PoLineItemData.isHold !== 1 && !this.state.PoLineItemData.DeletionIndicator ?
                                                                                                <div className="form-group pt-2 float-right">
                                                                                                    {el.uploadId != 0 ?
                                                                                                        <>
                                                                                                            <a href={FILESERVER_ROOT_URL + "files/Documents/" + el.uploadId + "/download"} target="_blank" download>
                                                                                                                <FontAwesomeIcon className="align-middle float-left mt-2 pr-2" style={{ marginLeft: "10px", marginRight: "5px" }} icon={"download"} color={"black"} title="Download" size="2x" />
                                                                                                            </a>
                                                                                                            <FontAwesomeIcon
                                                                                                                className="align-middle float-left mt-2 pr-2"
                                                                                                                icon={"code-branch"}
                                                                                                                color={"black"}
                                                                                                                title="Document Version"
                                                                                                                size="2x" onClick={() => this.OpenVersionModal(el.uploadId)} />
                                                                                                            <FontAwesomeIcon className="align-middle float-left mt-2 pr-2" icon={"sms"} color={el.Comments == null || el.Comments == 'NA' ? "block" : 'blue'} title="Comments" size="2x" onClick={() => this.documentComments({ actionType: "Supplier Documents", param: el }, el.uploadId)} />
                                                                                                        </>
                                                                                                        : null}

                                                                                                    <input type="file" className="form-control-file" style={{ width: "79%", float: "rigth" }} accept=".pdf" onChange={(e) => { this.handleFileInput(e, el.stageDocumentId, element.qATemplateStageId, el.uploadId) }} id="exampleFormControlFile1" />
                                                                                                </div>
                                                                                                : null}
                                                                                            {/* <span className="badge badge-info ml-4 mr-4">
                                                                                        File Size : 0MB
                                                                                    </span> */}

                                                                                            {el.status > 3 && <span className={"badge " + this.state.docStatus[el.status]['badge']}>
                                                                                                {el.status == 4 ? "Document has been rejected" : "Required another revised document"}
                                                                                            </span>}
                                                                                        </div>
                                                                                        :
                                                                                        <span className="badge badge-danger" style={{ marginTop: "12px", float: "right" }}>To Be Uploaded</span>
                                                                            }
                                                                        </>)}

                                                                </div>))
                                                            }
                                                            )}

                                                        </div>{
                                                            roles[1] || roles[4] || roles[6] ?
                                                                <div className=" col ml-4 pt-2 ">
                                                                    {console.log(element.canSendToVendor, element.canSendtoPlanner)}
                                                                    {/* <button className="btn2 btn-sms2 mt-2 ml-8 float-right" type="submit" onClick={()=>this.sendToVendor(element)} disabled={element.documents.filter(item=> item.status<2).length>0 ? false:true}>Send to {roles[5] ? "Planner":"Vendor"}</button> */}
                                                                    {(roles[5] || roles[7]) ?
                                                                        <button className="btn2 btn-sms2 rounded-pill mt-2 ml-8 float-right" type="submit" hidden={element.canSendtoPlanner ? false : true} onClick={() => this.sendToVendor(element)} disabled={element.documents.filter(item => item.status < 2).length > 0 ? false : true}>Send to Planner</button>
                                                                        : <button className="btn2 btn-sms2 rounded-pill mt-2 ml-8 float-right" type="submit" hidden={element.canSendToVendor ? false : true} onClick={() => this.sendToVendor(element)} disabled={element.documents.filter(item => item.status < 2).length > 0 ? false : true}>Send to Vendor</button>}

                                                                    <button className="btn2 btn-sms1 rounded-pill mt-2 mb-2 ml-4 float-right" hidden={this.state.uploadedfile ? false : true} onClick={this.onClickSave} type="submit" disabled={this.validateSaveBtn(element)}>Save As Draft</button>
                                                                </div>
                                                                : null
                                                        }

                                                        {
                                                            (roles[5] || roles[7]) && element.documents.filter(it => it.isSMS != true).length > 0 && <div className=" col ml-4 pt-2 ">
                                                                {/* <button className="btn2 btn-sms2 mt-2 ml-8 float-right" type="submit" onClick={()=>this.sendToVendor(element)} disabled={element.documents.filter(item=> (item.status<2)).length>0 ? false:true}>Send to {roles[5] ? "Planner":"Vendor"}</button> */}
                                                                {(roles[5] || roles[7]) ?
                                                                    <button className="btn2 btn-sms2 rounded-pill mt-2 ml-8 float-right" type="submit" hidden={element.canSendtoPlanner ? false : true} onClick={() => this.sendToVendor(element)} disabled={element.documents.filter(item => item.status < 2).length > 0 ? false : true}>Send to Planner</button>
                                                                    : <button className="btn2 btn-sms2 rounded-pill mt-2 ml-8 float-right" type="submit" hidden={element.canSendToVendor ? false : true} onClick={() => this.sendToVendor(element)} disabled={element.documents.filter(item => item.status < 2).length > 0 ? false : true}>Send to Vendor</button>}
                                                                <button className="btn2 btn-sms1 rounded-pill mt-2 mb-2 ml-4 float-right" onClick={this.onClickSave} type="submit" hidden={this.state.uploadedfile ? false : true} disabled={element.documents.filter(item => (item.status == 1 || item.status == 4 || item.status == 5)).length > 0 ? false : true}>Save As Draft</button>
                                                            </div>
                                                        }

                                                        {


                                                        }

                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card></div>)
                                        }) : () => {
                                            window.location.replace("/InspectiondashboardDocument")
                                        }
                                    }
                                </Accordion>
                                :
                                ""
                            }
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}



const mapStateToProps = (state) => ({
    poDetails: state.poDetails,
    qaDocuments: state.poDetails.qaDocuments,
    qaActivity: state.poDetails.qaActivity,
    qaDocumentsByPOLineItemId: state.poDetails.qaDocumentsByPOLineItemId,
    getstagesByPOLineitemID: state.poDetails,
    results: state, file: state.file,
    versions: state.file.file_versions
})
export default connect(mapStateToProps, {
    getstagesByPOLineitemID,
    GetDocumentsForQA,
    getQADocumentsByParams,
    postQADocumentForPOLineitemID,
    updateQADocumentStatus,
    uploadFileGeneric,
    getQAActivity,
    GenericUploadVersionFile,
    getPODetails,
    uploadFile,
    downloadFile,
    requestForVendorApproval,
    changeDocStatus, getDocumentVersions, postComment,
    uploadVersionFile, postAddStage, removeStage, WaiveOffInspection, getPODetailsWithPoLineItemId
})(Dashboard)
